import { autoMount } from '../../../utils/autoMount';
import { Companies } from '../../../components/pages/companies';

autoMount({ Companies });
